/** Curated Telegram-style animated emoji set.
 *  Maps a "hero" emoji to Google Noto Animated Emoji codepoint used in the Lottie CDN.
 *  URL pattern: https://fonts.gstatic.com/s/e/notoemoji/latest/{code}/lottie.json
 *  All 50 codepoints below are verified to have Lottie assets published.
 *
 *  Any emoji NOT in this map falls back to the static native glyph rendered jumbo
 *  with the standard bounce/float CSS animation.
 */
export const ANIMATED_EMOJIS = {
  "🎉": "1f389",
  "🎊": "1f38a",
  "🔥": "1f525",
  "💯": "1f4af",
  "👏": "1f44f",
  "🥳": "1f973",
  "❤️": "2764_fe0f",
  "❤": "2764_fe0f",
  "😂": "1f602",
  "😭": "1f62d",
  "🙏": "1f64f",
  "🕺": "1f57a",
  "💃": "1f483",
  "✨": "2728",
  "💥": "1f4a5",
  "🎈": "1f388",
  "🤩": "1f929",
  "😍": "1f60d",
  "🚀": "1f680",
  "👍": "1f44d",
  "👎": "1f44e",
  "😊": "1f60a",
  "😎": "1f60e",
  "🥰": "1f970",
  "🤣": "1f923",
  "😘": "1f618",
  "🤔": "1f914",
  "😴": "1f634",
  "😢": "1f622",
  "🤯": "1f92f",
  "😅": "1f605",
  "🎂": "1f382",
  "🌟": "1f31f",
  "⭐": "2b50",
  "🌈": "1f308",
  "☀️": "2600_fe0f",
  "☀": "2600_fe0f",
  "🌙": "1f319",
  "🍾": "1f37e",
  "🥂": "1f942",
  "🎁": "1f381",
  "💪": "1f4aa",
  "👀": "1f440",
  "💤": "1f4a4",
  "💔": "1f494",
  "💖": "1f496",
  "💕": "1f495",
  "🙈": "1f648",
  "🤗": "1f917",
  "🥺": "1f97a",
  "😇": "1f607",
  "😱": "1f631",
};

export function lottieUrlForEmoji(emoji) {
  const code = ANIMATED_EMOJIS[emoji];
  return code ? `https://fonts.gstatic.com/s/e/notoemoji/latest/${code}/lottie.json` : null;
}
